/**
 * The responsbility of this file is to provide a default ui before creating tickets, adding collobrators, Sending Invites etc...
 */

import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import TicketSvg from '../../assets/images/TicektIcon.svg';
import { Body2, H4 } from '../../themes/typography';

function AddList({
    image = TicketSvg,
    heading = 'Create Your Tickets',
    desc1 = 'Every great event starts with a ticket.',
    desc2 = "Let's create yours!",
    buttonText = 'Add Tickets',
    onClick = () => {}
}) {
    return (
        <div style={addMoreListContainer}>
            <div style={addListWrapper}>
                <div style={modalImageContainer}>
                    <img src={image} style={modalImage} alt="Modal" />
                </div>
                <div style={modalContent}>
                    <H4>{heading}</H4>
                    <div style={modalDescription}>
                        <Body2>{desc1}</Body2>
                        <Body2>{desc2}</Body2>
                    </div>
                </div>
                <Button variant="toggleActive" onClick={onClick}>
                    {buttonText}
                </Button>
            </div>
        </div>
    );
}

export default AddList;

// props type checking
AddList.propTypes = {
    image: PropTypes.string,
    heading: PropTypes.string,
    desc1: PropTypes.string,
    desc2: PropTypes.string,
    buttonText: PropTypes.string,
    onClick: PropTypes.func
};

// CSS
const addMoreListContainer = {
    margin: '2rem auto',
    padding: '2rem 0rem'
};

const addListWrapper = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1.5rem'
};

const modalContent = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem'
};

const modalDescription = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.4rem'
};

const modalImageContainer = {
    width: '100px'
};

const modalImage = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
};
